import styles from './BroadcastLayout.module.scss';

interface Props {
  children: React.ReactNode;
}

export const BroadcastMain = ({ children }: Props) => {
  return <main className={styles.main}>{children}</main>;
};
